import {TextButton} from '../../../index'

const ImageUploadButton = ({onClick}) => {
    return (
        <TextButton clickHandler={onClick}>Upload Image</TextButton>
    )
}

export default ImageUploadButton
